import {
  Box,
  Modal,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Button from "@ds-developer/button";
import React, { useRef, useState } from "react";
import useMutationAddNewDocument from "../../hooks/useMutationAddNewDocument";

type ModalAddNewDocumentProps = {
  isModalAddNewDocumentOpened: boolean;
  setIsModalAddNewDocumentOpened: (bool: boolean) => void;
  personKey: string;
  refetchDocs: () => void;
};

const useStyles = makeStyles(() => ({
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "50%",
    background: "#FFFFFF",
    padding: "24px 10px 24px 10px",
    overflow: "scroll",
  },
  formPad: {
    padding: "10%",
  },
  inputHund: {
    width: "100%",
    marginBottom: "5%",
  },
  buttonRight: {
    float: "right",
  },
  modalTitle: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    textAlign: "center",
    color: "#263238",
    marginBottom: "5%",
  },
  modalSubext: {
    margin: "0 5%",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.1px",
    color: "#263238",
  },
}));

export const ModalAddNewDocument: React.FC<ModalAddNewDocumentProps> = ({
  isModalAddNewDocumentOpened,
  setIsModalAddNewDocumentOpened,
  personKey,
  refetchDocs,
}) => {
  const classes = useStyles();
  const handleClose = () => {
    setIsModalAddNewDocumentOpened(false);
  };
  const [disableButton, setDisableButton] = useState(false);
  const [fileName, setFileName] = useState("");
  const inputRef = useRef(null);
  const [fileUpload, setFileUpload] = useState<File>();
  const [bufferSubida, setBufferSubida] = useState<Buffer>();

  const [franchiseAgreementAddNewDocument] = useMutationAddNewDocument(
    personKey,
    fileName,
    {
      onCompleted: () => {
        refetchDocs();
        setDisableButton(false);
        setIsModalAddNewDocumentOpened(false);
      },
    },
    {
      onError: () => {
        setDisableButton(false);
        setIsModalAddNewDocumentOpened(false);
      },
    },
    bufferSubida,
  );

  const franchiseAgreementAddNewDocumentFunc = async (
    personKey: string,
    file: File,
    fileName: string,
  ) => {
    const blob = await file.arrayBuffer();
    const bufferSubida = Buffer.from(blob);
    setBufferSubida(bufferSubida);
    franchiseAgreementAddNewDocument({
      variables: {
        instructorKey: personKey,
        file: bufferSubida,
        documentName: fileName,
      },
      awaitRefetchQueries: true,
    });
  };

  return (
    <>
      <Modal open={isModalAddNewDocumentOpened} onClose={handleClose}>
        <Box className={classes.box}>
          <Typography className={classes.modalTitle}>
            Upload new document
          </Typography>
          <form className={classes.formPad}>
            <TextField
              ref={inputRef}
              className={classes.inputHund}
              label="Document type"
              type="file"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={e => {
                setFileUpload((e.target as HTMLInputElement)?.files?.[0]);
              }}
            />
            <TextField
              className={classes.inputHund}
              label="Expiry date"
              type="date"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              className={classes.inputHund}
              label="Document description"
              type="test"
              onChange={e => {
                setFileName(e.target.value);
              }}
              variant="outlined"
            />
            <Button
              type="button"
              variant="outlined"
              color="inherit"
              onClick={() => setIsModalAddNewDocumentOpened(false)}
            >
              CANCEL
            </Button>
            <Button
              disabled={!fileUpload || disableButton}
              variant="contained"
              color="primary"
              className={classes.buttonRight}
              onClick={e => {
                e.preventDefault();
                setDisableButton(true);
                if (fileUpload) {
                  franchiseAgreementAddNewDocumentFunc(
                    personKey,
                    fileUpload,
                    fileName,
                  );
                }
              }}
            >
              UPLOAD
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
};
